import { useI18nContext } from './I18nProvider';
import { getStoredLanguage, storeLanguage } from './languageUtils';

/**
 * Custom hook that provides access to all language-related utilities
 * @returns An object containing the current language and all language utility functions
 */
export const useLanguage = () => {
  const { language, setLanguage } = useI18nContext();

  return {
    // Current language state
    language,
    setLanguage,

    // Utility functions
    getStoredLanguage,
    storeLanguage,
  };
};
